module.exports = __webpack_public_path__ + "img/Logo-luke.a97cab03.png";